export * from "./ClickToPaySuccessView";
export * from "./ClickToPayFailView";